import { Swiper, EffectFade, Lazy, Navigation, Pagination } from 'swiper';

document.addEventListener('DOMContentLoaded', () => {

  Swiper.use([EffectFade, Lazy, Navigation, Pagination]);

  var swiperNews
  var swiperVideo
  const breakpoint = window.matchMedia('(max-width:768px)')
  const wrapper = document.getElementById('newsSwiperWrapper')
  const videoSwiper = document.getElementById('videoSwiper')

  if(wrapper) {
    const breakpointChecker = function () {
        enableSwiper()
    }
    const enableSwiper = function() {
      swiperNews = new Swiper('#newsSwiper', {
        navigation: {
          nextEl: ".last-news .swiper-button-next",
          prevEl: ".last-news .swiper-button-prev",
        },
      })
    }

    breakpoint.addEventListener('change', breakpointChecker)
    let throttle = false
    window.addEventListener('resize', function() {
      if(throttle) return
      throttle = true
      breakpointChecker()
      setTimeout(() => {
        throttle = false
      }, 150)
    })
    breakpointChecker()

  }

  if(videoSwiper) {
    swiperVideo = new Swiper('#videoSwiper', {
      slidesPerView: 1,
      spaceBetween: 10,
      lazy: true,
      navigation: {
        nextEl: ".videos-block .swiper-button-next, .related-block .swiper-button-next",
        prevEl: ".videos-block .swiper-button-prev, .related-block .swiper-button-prev",
      },
      breakpoints: {
        480: {
          slidesPerView: 2,
          spaceBetween: 24
        },
        680: {
          slidesPerView: 3,
          spaceBetween: 24
        },
        860: {
          slidesPerView: 3,
          spaceBetween: 15
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 24
        }
      }
    })
  }

})


